import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";

export const dealerContactInfosReducer = function dealerContactInfosReducer(
  state = initialState.partners.dealerContactInfos,
  action
) {
  switch (action.type) {
    case types.LOAD_DEALER_CONTACT_INFOS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_DEALER_CONTACT_INFOS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };
      return result;
    }

    case types.LOAD_DEALER_CONTACT_INFOS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case types.UPDATE_DEALER_CONTACT_INFOS_SUCCEEDED: {
      const { key, ids } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false, ids: ids };
      return result;
    }

    default:
      return state;
  }
};
